import { Box, Typography } from "src/components";
import OnboardingAllSet from "src/assets/onboarding-all-set.png";
import { useIsMobile } from 'src/hooks';

export default function SuccessScreen() {
    const isMobile = useIsMobile();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            p={3}
            textAlign="center"
            >
            <Box
                component="img"
                src={OnboardingAllSet}
                alt="All Set"
                sx={{ width: "300px", maxWidth: "100%", mb: 2 }}
            />
            <Typography variant={isMobile ? "h4" : "h5"} fontWeight={700} gutterBottom>
                You're All Set!
            </Typography>
            <Typography variant={isMobile ? "body1" : "body2"}>
                Your profile is ready, and you're all set to explore. Welcome to the community!
            </Typography>
        </Box>
    );
}
